// removed by extract-text-webpack-plugin
module.exports = {"transitionDuration":"200ms","mask":"mask-1WJgi","enter":"enter-2m0Dw","exit":"exit-16idm","content":"content-3MP7q","scrollable":"scrollable-2Nl3E","smooth":"smooth-2K_e-","down":"down-N5Mps","pop":"pop-2Bi0i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/_modal.css
// module id = 1280
// module chunks = 1